export default __webpack_public_path__ + "media/images/features/local_delivery/episode2/LP_02-5facad8ae5d9fa2730e0867a603cb811.jpg";